import React from "react";
import UtentiAssociatiView from "./UtentiAssociatiView";

export default function UtentiAssociatiController({
                                            utentiAssociati,
                                            translate,
                                            setRelAssociatoSel,
                                            setShowModalDelAssociato,
                                        }) {

    function onClickEliminaUtentiAssociati(row) {
        setRelAssociatoSel(row);
        setShowModalDelAssociato(true);
    }

    return (
        <UtentiAssociatiView
            translate={translate}
            utentiAssociati={utentiAssociati}
            onClickEliminaUtentiAssociati={onClickEliminaUtentiAssociati}
        />
    );
}